export default __webpack_public_path__ + "static/media/mercadoPago.0a7bd375.png";